export default __webpack_public_path__ + "static/media/arrow-right-breadcrumb.cf64cda2.svg";